import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendForgotOtp, verifyForgotOtp } from "../slices/authSlice";
import { toast } from "react-toastify"; // ⭐ Add toast

const ForgotPasswordModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { loading, error, forgotOtpSent } = useSelector((s) => s.auth);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [cpassword, setCpassword] = useState("");

  const handleSendOtp = () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    dispatch(sendForgotOtp({ email })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("OTP sent to your email!");
      }
    });
  };

  const handleVerifyOtp = () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    if (!newPassword || !cpassword) {
      toast.error("Please enter both password fields");
      return;
    }

    if (newPassword !== cpassword) {
      toast.error("Passwords do not match");
      return;
    }

    dispatch(verifyForgotOtp({ email, otp, newPassword })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Password reset successful!");
        setEmail("");
        setOtp("");
        setNewPassword("");
        setCpassword("");
        onClose();
      }
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center"
      style={{ zIndex: 10000 }}
    >
      <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-xl">
        <h2 className="text-lg font-semibold text-center mb-4">
          Forgot Password
        </h2>

        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

        {!forgotOtpSent ? (
          <>
            <input
              type="email"
              placeholder="Enter Email"
              className="w-full p-2 border rounded-lg mb-3"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button
              onClick={handleSendOtp}
              disabled={loading}
              className="w-full bg-black text-white py-2 rounded-lg"
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              className="w-full p-2 border rounded-lg mb-3"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <input
              type="password"
              placeholder="New Password"
              className="w-full p-2 border rounded-lg mb-3"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Confirm Password"
              className="w-full p-2 border rounded-lg mb-3"
              value={cpassword}
              onChange={(e) => setCpassword(e.target.value)}
            />

            <button
              onClick={handleVerifyOtp}
              disabled={loading}
              className="w-full bg-black text-white py-2 rounded-lg"
            >
              {loading ? "Verifying..." : "Reset Password"}
            </button>
          </>
        )}

        <button
          onClick={onClose}
          className="mt-4 w-full py-2 bg-gray-200 rounded-lg"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
